import { RouterModule, Routes } from "@angular/router";
import { NgModule } from "@angular/core";
import { DemoApplyLayoutComponent } from "./demo-apply.layout";
import { DemoApplyComponent } from "./demo-apply.component";

export const routes: Routes = [
    {
        path: "",
        component: DemoApplyLayoutComponent,
        children: [
            {
                path: "",
                component: DemoApplyComponent,
            },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class DemoApplyRoutingModule {}
